<template>
    <div class="form-page">
        <header :class="{ 'disabled': loading }">
            <div class="container">
                <img
                    src="@/assets/img/upmood_icon.png"
                    alt="Upmood"
                    class="logo"
                > 

                <img
                    src="@/assets/img/icon/arrow-left.svg"
                    alt="<<<"
                    class="arrow-left"
                    @click="$router.push(routeBack)"
                >

                <h3>
                    <a @click.prevent="$router.push(routeBack)">
                        Home
                    </a>
                </h3>
            </div>
        </header>

        <nav>
            <div  class="container">
                <h2 v-if="title">
                    {{ title }}
                </h2>

                <slot name="nav" />
            </div>
        </nav>

        <section class="content-container">
            <div class="container">
                <slot name="content" />
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: ['title', 'routeBack', 'loading']
}
</script>

<style lang="scss" scoped>
.form-page {
    height: 100%;
    width: 100%;
    background-color: #FAFBFD;
    display: flex;
    flex-direction: column;
    header {
        background: #fff;
        padding: 20px 0;
        font-size: 1rem;

		&.disabled {
			pointer-events: none;
			cursor: not-allowed;
		}
        
        .container {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .logo {
                width: 50px;
                margin-right: 20px;
            }

            .arrow-left {
                cursor: pointer;
                margin-top: 2px;
                margin-right: 15px;
            }

            a {
                cursor: pointer;
                transition: 0.3s;

                &:hover {
                    color: #2DC4B6;
                }
            }
        }
    }

    nav {
        background-color: #F5F6FA;
    }

    nav h2 {
        padding: 20px 0;
    }


    .content-container {
        flex: 1 1 auto;
        width: 100%;
        padding: 20px 0;
        background-color: #FAFBFD;
        overflow: auto;

        .container {
            height: 100%;
        }
    }

    header .container {
        padding-left: 50px;
    }

    nav, .content-container {

        .container {
           padding-left: 150px;
       }
    }
}

</style>